import { useHistory } from 'react-router-dom';

const RouterAssigner = () => {
  window.reactRouterHistory = useHistory();

  return null;
};

export default RouterAssigner;
